var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "buttons" },
    _vm._l(_vm.buttonLabels, function(label, index) {
      return _c(
        "x-button",
        {
          key: `btn-${label}`,
          class: { selected: _vm.currentValue === index },
          on: { click: () => _vm.onClick(index) }
        },
        [_vm._v("\n    " + _vm._s(label) + "\n  ")]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }